import ColorFilter from 'filters/ColorFilter/ColorFilter';
import IconTypeFilter from 'filters/TypeFilter/IconTypeFilter';
import { FilterType } from 'rangeConfig/@types';
import DrawersIcon from 'rangeConfig/Icons/Drawers.svg?react';
import HangingRailsIcon from 'rangeConfig/Icons/HangingRail.svg?react';
import MeshBasketIcon from 'rangeConfig/Icons/MeshBasket.svg?react';
import OtherIcon from 'rangeConfig/Icons/Other.svg?react';
import ShelvesIcon from 'rangeConfig/Icons/Shelves.svg?react';
import ShoerackIcon from 'rangeConfig/Icons/Shoerack.svg?react';
import HingedDoorIcon from 'rangeConfig/Icons/HingedDoor.svg?react';
import SlidingDoorWithPanelsIcon from 'rangeConfig/Icons/SlidingDoorWithPanels.svg?react';
import HandlesTypeIcon from 'rangeConfig/Icons/HandlesType.svg?react';
import KnobsTypeIcon from 'rangeConfig/Icons/KnobsType.svg?react';
import { ProductType } from '@inter-ikea-storageone/range';

export const colorFilter = {
  component: ColorFilter,
  title: 'storageone.colorFilterLabel',
  id: 'color',
  type: FilterType.FILTER
};

export const doorsTypeFilter = {
  component: IconTypeFilter,
  title: 'storageone.typeFilterLabel',
  id: 'type',
  type: FilterType.FILTER,
  options: [
    {
      id: 'hingedDoor',
      name: 'storageone.filterOptionHingedDoor',
      icon: HingedDoorIcon,
      types: [ProductType.PAX_HINGE_DOOR_ASM]
    },
    {
      id: 'slidingDoor',
      name: 'storageone.filterOptionSlidingDoor',
      icon: SlidingDoorWithPanelsIcon,
      types: [
        ProductType.PAX_SLIDING_DOOR_REGULAR_ASM,
        ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM
      ]
    }
  ]
};

export const handlesTypeFilter = {
  component: IconTypeFilter,
  title: 'storageone.typeFilterLabel',
  id: 'type',
  type: FilterType.FILTER,
  options: [
    {
      id: 'handles',
      name: 'storageone.filterOptionHandles',
      icon: HandlesTypeIcon,
      types: [ProductType.HANDLE, ProductType.EDGE_HANDLE]
    },
    {
      id: 'knobs',
      name: 'storageone.filterOptionKnobs',
      icon: KnobsTypeIcon,
      types: [ProductType.KNOB]
    }
  ]
};

export const interiorsTypeFilter = {
  component: IconTypeFilter,
  title: 'storageone.typeFilterLabel',
  id: 'type',
  type: FilterType.FILTER,
  options: [
    {
      id: 'drawers',
      name: 'storageone.filterOptionDrawers',
      icon: DrawersIcon,
      types: [
        ProductType.PAX_DRAWER,
        ProductType.PAX_GLASS_DRAWER,
        ProductType.PAX_DRAWER_FRAMED_GLASS,
        ProductType.PAX_DRAWER_FRAMED,
        ProductType.PAX_DRAWER_LOCKABLE
      ]
    },
    {
      id: 'hangingRails',
      name: 'storageone.filterOptionClothesRails',
      icon: HangingRailsIcon,
      types: [
        ProductType.PAX_CLOTH_RAIL_350,
        ProductType.PAX_CLOTH_RAIL_580,
        ProductType.PAX_PULL_OUT_CLOTH_RAIL,
        ProductType.PAX_PULL_OUT_TROUSER_HANGER,
        ProductType.PAX_PULL_OUT_MULTI_USE_HANGER,
        ProductType.PAX_VALET_HANGER
      ]
    },
    {
      id: 'meshBasket',
      name: 'storageone.filterOptionMeshBaskets',
      icon: MeshBasketIcon,
      types: [ProductType.PAX_MESH_BASKET_ASM, ProductType.PAX_METAL_BASKET_ASM]
    },
    {
      id: 'shelves',
      name: 'storageone.filterOptionShelves',
      icon: ShelvesIcon,
      types: [
        ProductType.PAX_SHELF,
        ProductType.PAX_GLASS_SHELF,
        ProductType.PAX_PULL_OUT_TRAY,
        ProductType.PAX_PULL_OUT_TRAY_WITH_DIVIDER_INSERTS_ASM,
        ProductType.PAX_PULL_OUT_TRAY_WITH_COMPARTMENT_INSERTS_ASM,
        ProductType.PAX_PULL_OUT_TRAY_WITH_MAT_ASM
      ]
    },
    {
      id: 'shoerack',
      name: 'storageone.filterOptionShoeRacks',
      icon: ShoerackIcon,
      types: [
        ProductType.PAX_PULL_OUT_SHOE_SHELF,
        ProductType.PAX_SHOE_SHELF,
        ProductType.PAX_PULL_OUT_TRAY_WITH_SHOE_INSERTS_ASM
      ]
    },
    {
      id: 'other',
      name: 'storageone.filterOptionOther',
      icon: OtherIcon,
      types: [
        ProductType.PAX_PULL_OUT_STORAGE_BAG,
        ProductType.PAX_T_DIVIDER,
        ProductType.PAX_L_DIVIDER,
        ProductType.PAX_CLEANING_INTERIOR
      ]
    }
  ]
};
